import { mergePositional } from './positional';

export const mergeOrderList = (jsonData, translated) => ({
  ...jsonData,
  stimulus: translated.stimulus ?? jsonData.stimulus,
  list: mergePositional(jsonData.list, translated.list),
});
